"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseService = void 0;
const HttpService_1 = require("../../utils/HttpService");
class BaseService {
    constructor(serviceConfig = {}) {
        this.headers = {};
        const { baseURL, appInstance, additionalHeaders, enableRetry = true, revalidateAppInstance } = serviceConfig;
        this.enableRetry = enableRetry;
        this.httpService = new HttpService_1.HttpService({
            baseURL,
            appInstance,
            additionalHeaders,
            revalidateAppInstance,
        });
    }
    // TODO: cover with test
    setAppInstance(instance) {
        return this.httpService.setAppInstance(instance);
    }
    // TODO: cover with test
    setRevalidateAppInstance(fn) {
        return this.httpService.setRevalidateAppInstance(fn);
    }
    setBaseURL(baseURL) {
        this.httpService.setBaseURL(baseURL);
    }
    setHeaders(headers) {
        this.headers = headers;
    }
    request(requestConfig) {
        return this.httpService.request(Object.assign(Object.assign({}, requestConfig), { retryConfig: Object.assign(Object.assign({}, requestConfig.retryConfig), (!this.enableRetry && {
                shouldRetry: () => false,
            })), headers: this.headers }));
    }
}
exports.BaseService = BaseService;
//# sourceMappingURL=index.js.map